import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { shellRoute } from './index'
import { chessSearchSchema } from '../search'

export const chessRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: '/chess',
  validateSearch: chessSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/chess'), 'ChessPage'),
})
